import { 
    BOOKING_SUBMIT,
    GET_BOOKINGS
} from "./types";

export const createBooking = (data) => (dispatch, getState) => {
    return new Promise((resolve, reject) => {
        fetch(`${process.env.REACT_APP_API_URL}/api/v1/bookings/create`, {
            method: "POST",
            headers: {
                "content-type": "application/json"
            },
            body: JSON.stringify(data)
        })
            .then(res => res.json())
            .then(booking => {
              console.log(booking);
                dispatch({
                    type: BOOKING_SUBMIT,
                    payload: booking
                });

                if (!booking.ok) {
                  console.log("reject");
                    reject(booking);
                } else {
                  console.log("worked");
                    resolve(booking);
                }
            })
            .catch(err => console.log(err));
    });
};

export const getBookings = () => (dispatch, getState) => {
    return new Promise((resolve, reject) => {

        fetch(`${process.env.REACT_APP_API_URL}/api/v1/bookings/`, {
            method: "GET",
            headers: {
                "content-type": "application/json"
            }
        })
            .then(res => res.json())
            .then(booking => {
                dispatch({
                    type: GET_BOOKINGS,
                    payload: booking
                });
                
                if (!booking.ok) {
                    reject(booking);
                } else {
                    resolve(booking);
                }
            });
    });
};

export const getBookingById = (bookingId) => (dispatch, getState) => {
    return new Promise((resolve, reject) => {

        fetch(`${process.env.REACT_APP_API_URL}/api/v1/bookings/get/${bookingId}`, {
            method: "GET",
            headers: {
                "content-type": "application/json"
            }
        })
            .then(res => res.json())
            .then(booking => {
                dispatch({
                    type: BOOKING_SUBMIT,
                    payload: booking
                });
                
                if (!booking.ok) {
                    reject(booking);
                } else {
                    resolve(booking);
                }
            });
    });
};
